import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20dark%20atmosphere%20with%20abstract%20film%20reel%20and%20theater%20curtains%2C%20deep%20black%20and%20crimson%20red%20gradient%2C%20dramatic%20stage%20lighting%20effect%2C%20movie%20theater%20ambiance%2C%20luxurious%20velvet%20texture%2C%20golden%20spotlight%20rays&width=1920&height=1080&seq=90movies-hero-bg&orientation=landscape"
          alt="90影视背景"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-background-50"></div>

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-4 md:px-6 py-20 md:py-28 text-center">
        <div className="inline-flex items-center gap-2 bg-primary-500/20 border border-primary-500/30 rounded-full px-4 py-1.5 mb-6">
          <span className="w-2 h-2 bg-primary-400 rounded-full animate-pulse"></span>
          <span className="text-primary-300 text-xs md:text-sm font-medium">每日更新 · 永不断更</span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-50 mb-4 leading-tight font-heading">
          免费在线观看
          <br />
          <span className="text-primary-400">不缓冲 · 无广告</span>
        </h1>

        <p className="text-foreground-300 text-sm md:text-base max-w-2xl mx-auto mb-8 leading-relaxed">
          海量电影、电视剧、综艺、动漫高清资源，每日更新最新热剧，
          <br className="hidden sm:block" />
          流畅播放不卡顿，纯净无广告，省钱追剧首选90影视
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/movie"
            className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-lg transition-all duration-200 whitespace-nowrap text-sm cursor-pointer"
          >
            <i className="ri-play-circle-line mr-2"></i>
            开始观影
          </Link>
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3 bg-background-100/80 hover:bg-background-200/80 text-foreground-200 font-medium rounded-lg border border-background-300/60 transition-all duration-200 whitespace-nowrap text-sm cursor-pointer"
          >
            了解更多
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mt-12 md:mt-16 max-w-3xl mx-auto">
          <div className="text-center">
            <div className="text-xl md:text-2xl font-bold text-accent-400 font-heading">10万+</div>
            <div className="text-foreground-500 text-xs mt-1">影视资源</div>
          </div>
          <div className="text-center">
            <div className="text-xl md:text-2xl font-bold text-accent-400 font-heading">1080P</div>
            <div className="text-foreground-500 text-xs mt-1">高清画质</div>
          </div>
          <div className="text-center">
            <div className="text-xl md:text-2xl font-bold text-accent-400 font-heading">5000万+</div>
            <div className="text-foreground-500 text-xs mt-1">累计用户</div>
          </div>
          <div className="text-center">
            <div className="text-xl md:text-2xl font-bold text-accent-400 font-heading">0广告</div>
            <div className="text-foreground-500 text-xs mt-1">纯净体验</div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function CategoryGridSection() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-50 font-heading mb-3">海量内容分类</h2>
          <p className="text-foreground-500 text-sm">电影、电视剧、综艺、动漫，你想看的这里都有</p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5">
          <Link
            to="/category/movie"
            className="group relative overflow-hidden rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-500/30 transition-all duration-300 p-6 md:p-8 text-center cursor-pointer"
          >
            <div className="absolute inset-0 bg-gradient-to-br from-red-500/20 to-orange-500/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            <div className="relative z-10">
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-4 bg-background-200/60 group-hover:bg-background-200 rounded-2xl flex items-center justify-center transition-all duration-300">
                <i className="ri-film-line text-2xl md:text-3xl text-primary-400 group-hover:text-primary-300 transition-colors"></i>
              </div>
              <h3 className="text-foreground-200 font-semibold text-sm md:text-base font-heading mb-1">电影</h3>
              <p className="text-foreground-600 text-xs">动作 科幻 悬疑 喜剧</p>
            </div>
          </Link>
          <Link
            to="/category/tv"
            className="group relative overflow-hidden rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-500/30 transition-all duration-300 p-6 md:p-8 text-center cursor-pointer"
          >
            <div className="absolute inset-0 bg-gradient-to-br from-blue-500/20 to-cyan-500/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            <div className="relative z-10">
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-4 bg-background-200/60 group-hover:bg-background-200 rounded-2xl flex items-center justify-center transition-all duration-300">
                <i className="ri-tv-line text-2xl md:text-3xl text-primary-400 group-hover:text-primary-300 transition-colors"></i>
              </div>
              <h3 className="text-foreground-200 font-semibold text-sm md:text-base font-heading mb-1">电视剧</h3>
              <p className="text-foreground-600 text-xs">古装 都市 刑侦 爱情</p>
            </div>
          </Link>
          <Link
            to="/category/variety"
            className="group relative overflow-hidden rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-500/30 transition-all duration-300 p-6 md:p-8 text-center cursor-pointer"
          >
            <div className="absolute inset-0 bg-gradient-to-br from-green-500/20 to-emerald-500/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            <div className="relative z-10">
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-4 bg-background-200/60 group-hover:bg-background-200 rounded-2xl flex items-center justify-center transition-all duration-300">
                <i className="ri-live-line text-2xl md:text-3xl text-primary-400 group-hover:text-primary-300 transition-colors"></i>
              </div>
              <h3 className="text-foreground-200 font-semibold text-sm md:text-base font-heading mb-1">综艺</h3>
              <p className="text-foreground-600 text-xs">真人秀 音乐 竞技 搞笑</p>
            </div>
          </Link>
          <Link
            to="/category/anime"
            className="group relative overflow-hidden rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-500/30 transition-all duration-300 p-6 md:p-8 text-center cursor-pointer"
          >
            <div className="absolute inset-0 bg-gradient-to-br from-purple-500/20 to-pink-500/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            <div className="relative z-10">
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-4 bg-background-200/60 group-hover:bg-background-200 rounded-2xl flex items-center justify-center transition-all duration-300">
                <i className="ri-ghost-smile-line text-2xl md:text-3xl text-primary-400 group-hover:text-primary-300 transition-colors"></i>
              </div>
              <h3 className="text-foreground-200 font-semibold text-sm md:text-base font-heading mb-1">动漫</h3>
              <p className="text-foreground-600 text-xs">国漫 日漫 动画电影</p>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}

export function HotPicksSection() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-50 font-heading mb-2">热门推荐</h2>
            <p className="text-foreground-500 text-sm">大家都在看的精彩内容</p>
          </div>
          <Link
            to="/category/movie"
            className="hidden sm:flex items-center gap-1 text-primary-400 hover:text-primary-300 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          <Link to="/article/m1" className="group relative overflow-hidden rounded-lg bg-background-200/60 border border-background-200/70 hover:border-primary-500/30 transition-all duration-300 cursor-pointer">
            <div className="aspect-[2/3] overflow-hidden">
              <img src="https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20epic%20astronaut%20in%20space%20dramatic%20cinematic%20lighting%20blue%20orange%20accents%20movie%20poster%20style&width=400&height=600&seq=hot-m1&orientation=portrait" alt="流浪地球3" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              <div className="absolute top-2 right-2 bg-background-950/80 backdrop-blur-sm rounded-md px-2 py-0.5 flex items-center gap-1">
                <i className="ri-star-fill text-accent-400 text-xs"></i>
                <span className="text-accent-400 text-xs font-semibold">9.2</span>
              </div>
            </div>
            <div className="p-3">
              <h3 className="text-foreground-100 text-sm font-medium truncate font-heading group-hover:text-primary-400 transition-colors">流浪地球3</h3>
              <p className="text-foreground-600 text-xs mt-1">电影</p>
            </div>
          </Link>

          <Link to="/article/m3" className="group relative overflow-hidden rounded-lg bg-background-200/60 border border-background-200/70 hover:border-primary-500/30 transition-all duration-300 cursor-pointer">
            <div className="aspect-[2/3] overflow-hidden">
              <img src="https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20poster%20ancient%20palace%20warrior%20traditional%20costume%20dramatic%20lighting%20epic%20cinematic&width=400&height=600&seq=hot-m3&orientation=portrait" alt="庆余年第二季" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              <div className="absolute top-2 right-2 bg-background-950/80 backdrop-blur-sm rounded-md px-2 py-0.5 flex items-center gap-1">
                <i className="ri-star-fill text-accent-400 text-xs"></i>
                <span className="text-accent-400 text-xs font-semibold">9.3</span>
              </div>
            </div>
            <div className="p-3">
              <h3 className="text-foreground-100 text-sm font-medium truncate font-heading group-hover:text-primary-400 transition-colors">庆余年第二季</h3>
              <p className="text-foreground-600 text-xs mt-1">电视剧</p>
            </div>
          </Link>

          <Link to="/article/m2" className="group relative overflow-hidden rounded-lg bg-background-200/60 border border-background-200/70 hover:border-primary-500/30 transition-all duration-300 cursor-pointer">
            <div className="aspect-[2/3] overflow-hidden">
              <img src="https://readdy.ai/api/search-image?query=Chinese%20animated%20film%20poster%20Nezha%20fire%20wheels%20red%20ribbon%20dynamic%20action%20mythological%20fiery%20background&width=400&height=600&seq=hot-m2&orientation=portrait" alt="哪吒之魔童闹海" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              <div className="absolute top-2 right-2 bg-background-950/80 backdrop-blur-sm rounded-md px-2 py-0.5 flex items-center gap-1">
                <i className="ri-star-fill text-accent-400 text-xs"></i>
                <span className="text-accent-400 text-xs font-semibold">9.5</span>
              </div>
            </div>
            <div className="p-3">
              <h3 className="text-foreground-100 text-sm font-medium truncate font-heading group-hover:text-primary-400 transition-colors">哪吒之魔童闹海</h3>
              <p className="text-foreground-600 text-xs mt-1">动漫</p>
            </div>
          </Link>

          <Link to="/article/m7" className="group relative overflow-hidden rounded-lg bg-background-200/60 border border-background-200/70 hover:border-primary-500/30 transition-all duration-300 cursor-pointer">
            <div className="aspect-[2/3] overflow-hidden">
              <img src="https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20poster%201990s%20Shanghai%20nostalgic%20neon%20lights%20elegant%20suit%20golden%20warm%20tones%20cinematic&width=400&height=600&seq=hot-m7&orientation=portrait" alt="繁花" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              <div className="absolute top-2 right-2 bg-background-950/80 backdrop-blur-sm rounded-md px-2 py-0.5 flex items-center gap-1">
                <i className="ri-star-fill text-accent-400 text-xs"></i>
                <span className="text-accent-400 text-xs font-semibold">9.4</span>
              </div>
            </div>
            <div className="p-3">
              <h3 className="text-foreground-100 text-sm font-medium truncate font-heading group-hover:text-primary-400 transition-colors">繁花</h3>
              <p className="text-foreground-600 text-xs mt-1">电视剧</p>
            </div>
          </Link>

          <Link to="/article/m5" className="group relative overflow-hidden rounded-lg bg-background-200/60 border border-background-200/70 hover:border-primary-500/30 transition-all duration-300 cursor-pointer">
            <div className="aspect-[2/3] overflow-hidden">
              <img src="https://readdy.ai/api/search-image?query=Chinese%20mythological%20fantasy%20movie%20poster%20ancient%20warriors%20mythical%20creatures%20epic%20battle%20golden%20crimson&width=400&height=600&seq=hot-m5&orientation=portrait" alt="封神第二部" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              <div className="absolute top-2 right-2 bg-background-950/80 backdrop-blur-sm rounded-md px-2 py-0.5 flex items-center gap-1">
                <i className="ri-star-fill text-accent-400 text-xs"></i>
                <span className="text-accent-400 text-xs font-semibold">9.0</span>
              </div>
            </div>
            <div className="p-3">
              <h3 className="text-foreground-100 text-sm font-medium truncate font-heading group-hover:text-primary-400 transition-colors">封神第二部</h3>
              <p className="text-foreground-600 text-xs mt-1">电影</p>
            </div>
          </Link>

          <Link to="/article/m9" className="group relative overflow-hidden rounded-lg bg-background-200/60 border border-background-200/70 hover:border-primary-500/30 transition-all duration-300 cursor-pointer">
            <div className="aspect-[2/3] overflow-hidden">
              <img src="https://readdy.ai/api/search-image?query=Chinese%20animated%20historical%20film%20poster%20Tang%20Dynasty%20Chang%20an%20poets%20traditional%20robes%20moonlit%20ink%20wash%20painting&width=400&height=600&seq=hot-m9&orientation=portrait" alt="长安三万里" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              <div className="absolute top-2 right-2 bg-background-950/80 backdrop-blur-sm rounded-md px-2 py-0.5 flex items-center gap-1">
                <i className="ri-star-fill text-accent-400 text-xs"></i>
                <span className="text-accent-400 text-xs font-semibold">9.3</span>
              </div>
            </div>
            <div className="p-3">
              <h3 className="text-foreground-100 text-sm font-medium truncate font-heading group-hover:text-primary-400 transition-colors">长安三万里</h3>
              <p className="text-foreground-600 text-xs mt-1">动漫</p>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}

export function LatestUpdatesSection() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-50 font-heading mb-2">最新更新</h2>
            <p className="text-foreground-500 text-sm">每日更新最新影视资源</p>
          </div>
          <Link
            to="/category/movie"
            className="hidden sm:flex items-center gap-1 text-primary-400 hover:text-primary-300 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          <Link to="/article/m1" className="group relative overflow-hidden rounded-lg bg-background-100 border border-background-200/70 hover:border-primary-500/30 transition-all duration-300 cursor-pointer">
            <div className="aspect-video overflow-hidden">
              <img src="https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20still%20epic%20astronaut%20in%20space%20dramatic%20cinematic%20lighting%20blue%20orange%20accents&width=640&height=360&seq=latest-m1&orientation=landscape" alt="流浪地球3" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              <div className="absolute top-2 left-2 bg-primary-500 text-background-50 text-xs px-2 py-0.5 rounded-md font-medium">NEW</div>
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/80 via-transparent to-transparent"></div>
            </div>
            <div className="p-3">
              <h3 className="text-foreground-100 text-sm font-medium truncate font-heading group-hover:text-primary-400 transition-colors">流浪地球3</h3>
              <p className="text-foreground-600 text-xs mt-1">电影</p>
            </div>
          </Link>

          <Link to="/article/m3" className="group relative overflow-hidden rounded-lg bg-background-100 border border-background-200/70 hover:border-primary-500/30 transition-all duration-300 cursor-pointer">
            <div className="aspect-video overflow-hidden">
              <img src="https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20still%20ancient%20palace%20warrior%20traditional%20costume%20dramatic%20lighting&width=640&height=360&seq=latest-m3&orientation=landscape" alt="庆余年第二季" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              <div className="absolute top-2 left-2 bg-primary-500 text-background-50 text-xs px-2 py-0.5 rounded-md font-medium">NEW</div>
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/80 via-transparent to-transparent"></div>
            </div>
            <div className="p-3">
              <h3 className="text-foreground-100 text-sm font-medium truncate font-heading group-hover:text-primary-400 transition-colors">庆余年第二季</h3>
              <p className="text-foreground-600 text-xs mt-1">电视剧</p>
            </div>
          </Link>

          <Link to="/article/m4" className="group relative overflow-hidden rounded-lg bg-background-100 border border-background-200/70 hover:border-primary-500/30 transition-all duration-300 cursor-pointer">
            <div className="aspect-video overflow-hidden">
              <img src="https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20still%20celebrities%20running%20laughing%20colorful%20dynamic%20outdoor%20energetic&width=640&height=360&seq=latest-m4&orientation=landscape" alt="奔跑吧第八季" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              <div className="absolute top-2 left-2 bg-primary-500 text-background-50 text-xs px-2 py-0.5 rounded-md font-medium">NEW</div>
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/80 via-transparent to-transparent"></div>
            </div>
            <div className="p-3">
              <h3 className="text-foreground-100 text-sm font-medium truncate font-heading group-hover:text-primary-400 transition-colors">奔跑吧第八季</h3>
              <p className="text-foreground-600 text-xs mt-1">综艺</p>
            </div>
          </Link>

          <Link to="/article/m8" className="group relative overflow-hidden rounded-lg bg-background-100 border border-background-200/70 hover:border-primary-500/30 transition-all duration-300 cursor-pointer">
            <div className="aspect-video overflow-hidden">
              <img src="https://readdy.ai/api/search-image?query=Chinese%20music%20competition%20show%20still%20male%20celebrities%20stylish%20stage%20concert%20lighting&width=640&height=360&seq=latest-m8&orientation=landscape" alt="披荆斩棘4" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              <div className="absolute top-2 left-2 bg-primary-500 text-background-50 text-xs px-2 py-0.5 rounded-md font-medium">NEW</div>
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/80 via-transparent to-transparent"></div>
            </div>
            <div className="p-3">
              <h3 className="text-foreground-100 text-sm font-medium truncate font-heading group-hover:text-primary-400 transition-colors">披荆斩棘4</h3>
              <p className="text-foreground-600 text-xs mt-1">综艺</p>
            </div>
          </Link>

          <Link to="/article/m5" className="group relative overflow-hidden rounded-lg bg-background-100 border border-background-200/70 hover:border-primary-500/30 transition-all duration-300 cursor-pointer">
            <div className="aspect-video overflow-hidden">
              <img src="https://readdy.ai/api/search-image?query=Chinese%20mythological%20fantasy%20movie%20still%20ancient%20warriors%20mythical%20creatures%20epic%20battle&width=640&height=360&seq=latest-m5&orientation=landscape" alt="封神第二部" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/80 via-transparent to-transparent"></div>
            </div>
            <div className="p-3">
              <h3 className="text-foreground-100 text-sm font-medium truncate font-heading group-hover:text-primary-400 transition-colors">封神第二部</h3>
              <p className="text-foreground-600 text-xs mt-1">电影</p>
            </div>
          </Link>

          <Link to="/article/m6" className="group relative overflow-hidden rounded-lg bg-background-100 border border-background-200/70 hover:border-primary-500/30 transition-all duration-300 cursor-pointer">
            <div className="aspect-video overflow-hidden">
              <img src="https://readdy.ai/api/search-image?query=Chinese%20anime%20still%20two%20young%20men%20mysterious%20time-travel%20clock%20motif%20urban%20fantasy&width=640&height=360&seq=latest-m6&orientation=landscape" alt="时光代理人" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/80 via-transparent to-transparent"></div>
            </div>
            <div className="p-3">
              <h3 className="text-foreground-100 text-sm font-medium truncate font-heading group-hover:text-primary-400 transition-colors">时光代理人</h3>
              <p className="text-foreground-600 text-xs mt-1">动漫</p>
            </div>
          </Link>

          <Link to="/article/m10" className="group relative overflow-hidden rounded-lg bg-background-100 border border-background-200/70 hover:border-primary-500/30 transition-all duration-300 cursor-pointer">
            <div className="aspect-video overflow-hidden">
              <img src="https://readdy.ai/api/search-image?query=Chinese%20historical%20suspense%20movie%20still%20ancient%20courtyard%20night%20lanterns%20mysterious%20red%20black&width=640&height=360&seq=latest-m10&orientation=landscape" alt="满江红" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/80 via-transparent to-transparent"></div>
            </div>
            <div className="p-3">
              <h3 className="text-foreground-100 text-sm font-medium truncate font-heading group-hover:text-primary-400 transition-colors">满江红</h3>
              <p className="text-foreground-600 text-xs mt-1">电影</p>
            </div>
          </Link>

          <Link to="/article/m11" className="group relative overflow-hidden rounded-lg bg-background-100 border border-background-200/70 hover:border-primary-500/30 transition-all duration-300 cursor-pointer">
            <div className="aspect-video overflow-hidden">
              <img src="https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20drama%20still%20police%20officer%20gangster%20facing%20off%20dark%20urban%20noir&width=640&height=360&seq=latest-m11&orientation=landscape" alt="狂飙" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/80 via-transparent to-transparent"></div>
            </div>
            <div className="p-3">
              <h3 className="text-foreground-100 text-sm font-medium truncate font-heading group-hover:text-primary-400 transition-colors">狂飙</h3>
              <p className="text-foreground-600 text-xs mt-1">电视剧</p>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}

export function FeaturesBanner() {
  return (
    <section className="w-full py-10 bg-background-100 border-y border-background-200/70">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          <div className="flex items-center gap-3 justify-center">
            <div className="w-10 h-10 rounded-lg bg-accent-500/10 flex items-center justify-center flex-shrink-0">
              <i className="ri-shield-check-line text-accent-400 text-lg"></i>
            </div>
            <div>
              <div className="text-foreground-200 font-semibold text-sm">无广告</div>
              <div className="text-foreground-600 text-xs">纯净观影体验</div>
            </div>
          </div>
          <div className="flex items-center gap-3 justify-center">
            <div className="w-10 h-10 rounded-lg bg-accent-500/10 flex items-center justify-center flex-shrink-0">
              <i className="ri-speed-up-line text-accent-400 text-lg"></i>
            </div>
            <div>
              <div className="text-foreground-200 font-semibold text-sm">不缓冲</div>
              <div className="text-foreground-600 text-xs">流畅高清播放</div>
            </div>
          </div>
          <div className="flex items-center gap-3 justify-center">
            <div className="w-10 h-10 rounded-lg bg-accent-500/10 flex items-center justify-center flex-shrink-0">
              <i className="ri-4k-line text-accent-400 text-lg"></i>
            </div>
            <div>
              <div className="text-foreground-200 font-semibold text-sm">1080P</div>
              <div className="text-foreground-600 text-xs">超高清画质</div>
            </div>
          </div>
          <div className="flex items-center gap-3 justify-center">
            <div className="w-10 h-10 rounded-lg bg-accent-500/10 flex items-center justify-center flex-shrink-0">
              <i className="ri-refresh-line text-accent-400 text-lg"></i>
            </div>
            <div>
              <div className="text-foreground-200 font-semibold text-sm">每日更新</div>
              <div className="text-foreground-600 text-xs">最新影视资源</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}